interface Theme {
  colors: {
    backgroundColor: string;
    borderColor: string;
    lightBorderColor: string;
    darkDisabledColor: string;
    lightDisabledColor: string;
    darkHoverColor: string;
    lightColor: string;
    darkColor: string;
    grayText: string;
    listItemHover: string;
    textHoverColor: string;
    lightGrayText: string;
    placeholderText: string;
    grayScroll: string;
    feedbackBackgroundColor: string;
    feedbackBackgroundHover: string;
    suggestionMerged: string;
    suggestionMergedLight: string;
  };
}

const theme: Theme = {
  colors: {
    backgroundColor: "white",
    borderColor: "#CCCCCC",
    lightBorderColor: "#B0AFAD",
    darkDisabledColor: "#B4B3B0",
    lightDisabledColor: "#E7E6E3",
    darkHoverColor: "#333333",
    lightColor: "#FFFFFF",
    darkColor: "#171715",
    grayText: "#555555",
    listItemHover: "#f4ece0",
    textHoverColor: "#595959",
    lightGrayText: "#9D9D9D",
    placeholderText: "#B8B8B8",
    grayScroll: "#CECECE",
    feedbackBackgroundColor: "#F4ECE0",
    feedbackBackgroundHover: "#f3e8d8",
    suggestionMerged: "#209D43",
    suggestionMergedLight: "#D3EBD9",
  },
};

export default theme;
